import { ref } from 'vue'

const STORAGE_KEY = 'lensvet_last_inventory_object_id'

/** Прочитать сохранённый `object_id` из localStorage (0, если нет/невалиден). */
function readStoredObjectId(): number {
  if (typeof localStorage === 'undefined') return 0
  const n = Number(localStorage.getItem(STORAGE_KEY))
  return Number.isFinite(n) && n > 0 ? n : 0
}

/**
 * Последний `object_id` из маршрута `/objects/groups/:object_id/...` (и аналогичных).
 * Нужен для API инвентаря на экранах без `object_id` в URL (например, подписки в профиле).
 */
export const lastInventoryRouteObjectId = ref(readStoredObjectId())

/**
 * Запомнить `object_id` текущего маршрута (в памяти и localStorage).
 *
 * @param raw значение `object_id` из параметров маршрута
 */
export function rememberInventoryRouteObjectId(raw: unknown) {
  const n = Number(raw)
  if (!Number.isFinite(n) || n <= 0) return
  lastInventoryRouteObjectId.value = n
  try {
    localStorage.setItem(STORAGE_KEY, String(n))
  } catch {
    /* ignore quota / private mode */
  }
}

/** Основная группа каталога инвентаря (если `object_group` пользователя — не та группа, где лежат типы). */
export function inventoryPrimaryObjectGroupIdFromEnv(): number {
  const n = Number(import.meta.env.VITE_INVENTORY_PRIMARY_OBJECT_GROUP_ID)
  return Number.isFinite(n) && n > 0 ? n : 0
}
